import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { LOC_KEY_MENU_PANEL_QUICK_ACCESS } from "../../locKeys";
import { QuickAccessMenuHeaderComponent, QuickAccessMenuHeaderComponentProps } from "../QuickAccessMenuHeaderComponent";

const mapStateToProps: MapStateToProps<QuickAccessMenuHeaderComponentProps, NoneOwnProps, IAppState> = (state) => ({
    title: getPrimaryText(state, LOC_KEY_MENU_PANEL_QUICK_ACCESS),
});

/** Získává lokalizovaný nadpis pro menu vyhledávání */
export const QuickAccessMenuHeader = connect(mapStateToProps)(QuickAccessMenuHeaderComponent);
